import type { z } from "@hono/zod-openapi";
import { onDriverRefs, onVehicleRefs } from "../../refs";

/**
 * The driver who took or left a seat, and the unit it was on — both always present.
 *
 * Here the driver *is* the subject: a transition without one means nothing, which is why this reference is required
 * where `StopEvent`'s actor is nullable. The other seat is never referenced. A swap is stated as each driver's own
 * pair of transitions at the same instant, so no event needs to name who else was aboard.
 */
export const vehicleDriverAssignmentTransitionRefs = { ...onDriverRefs, ...onVehicleRefs };

export type VehicleDriverAssignmentTransitionRefs = z.infer<z.ZodObject<typeof vehicleDriverAssignmentTransitionRefs>>;
